"use client";

import { AgentTextClassMap } from "../const";
import React, { FC, memo } from "react";

import { I18nUtil } from "@utils/i18n";
import NextImage from "@/src/components/NextImage";
import { ReportsList } from "./ReportsList";
import Translations from "@translate/components/CoPilot/360Reports/Reports360";
import { cn } from "utils";
import { useReports360Timeline } from "./hooks/useReports360Timeline";
const I18n = I18nUtil.createScoped(Translations);
interface Reports360Props {
  className?: string;
  agentId?: string;
}

/**
 * Reports360 主组件
 * 显示360报告列表页面
 *
 * @param props Reports360Props
 * @returns React.ReactElement
 */
export const Reports360: FC<Reports360Props> = memo(
  ({ className, agentId }) => {
    const {
      data,
      isLoading,
      isFetchingNextPage,
      hasNextPage,
      loadMore,
      error,
    } = useReports360Timeline({
      agentIds: agentId?.split(","),
    });
    return (
      <div
        className={cn("flex flex-col gap-4 h-full", className)}
        data-tracking-scope="reports-360"
      >
        {/* 标题和描述区域 */}
        <div
          className="flex flex-col gap-4 w-full"
          data-tracking-scope="reports-360-title"
        >
          {/* 标题 */}
          <h2
            aria-label="Reports360 h2"
            data-openreplay-label="Reports360 h2 Semantic"
            id="sem-reports360-h2"
            className="flex body_bold_l text-content_primary gap-2"
          >
            <NextImage
              src="/assets/images/agent-tip.svg"
              alt="360º Reports"
              width={20}
              height={20}
            />
            <span className={AgentTextClassMap["360"]}>
              {I18n.t("360º Reports For You")}
            </span>
          </h2>
        </div>
        {/* 列表区域 */}
        <div
          className="flex md:flex-row flex-col gap-4 overflow-y-auto no-scrollbar flex-1 min-h-0"
          data-tracking-scope="reports-360-list"
        >
          <ReportsList
            data={data}
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            onLoadMore={loadMore}
            error={error}
          />
        </div>
      </div>
    );
  },
);

Reports360.displayName = "Reports360";
